var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getOidRoot, } from '@verdant-web/common';
export class MessageCreator {
    constructor(meta) {
        this.meta = meta;
        this.createOperation = async (init) => {
            const localInfo = await this.meta.localReplica.get();
            return {
                type: 'op',
                timestamp: this.meta.now,
                replicaId: localInfo.id,
                operations: init.operations.map((op) => ({
                    data: op.data,
                    oid: op.oid,
                    timestamp: op.timestamp,
                })),
            };
        };
        this.createMigrationOperation = async (_a) => {
            var { targetVersion } = _a, init = __rest(_a, ["targetVersion"]);
            const localInfo = await this.meta.localReplica.get();
            return {
                type: 'op',
                operations: init.operations.map((op) => (Object.assign(Object.assign({}, op), { timestamp: this.meta.time.zero(targetVersion) }))),
                timestamp: this.meta.time.zero(targetVersion),
                replicaId: localInfo.id,
            };
        };
        /**
         * @param since - override local understanding of last sync time
         */
        this.createSyncStep1 = async (since) => {
            const localReplicaInfo = await this.meta.localReplica.get();
            const provideChangesSince = since === null ? null : localReplicaInfo.lastSyncedLogicalTime;
            // collect all of our operations that are newer than the server's last operation
            // if server replica isn't stored, we're syncing for the first time.
            const operations = [];
            const affectedDocs = new Set();
            // FIXME: this branch gives bad vibes. should we always
            // send all operations from other replicas too? is there
            // ever a case where we have a "since" timestamp and there
            // are foreign ops that match it?
            if (provideChangesSince) {
                await this.meta.operations.iterateOverAllLocalOperations((patch) => {
                    operations.push({
                        data: patch.data,
                        oid: patch.oid,
                        timestamp: patch.timestamp,
                    });
                    affectedDocs.add(getOidRoot(patch.oid));
                }, {
                    after: provideChangesSince,
                    // block on writes to prevent race conditions
                    mode: 'readwrite',
                });
            }
            else {
                // if providing the whole history, don't limit to only local
                // operations
                await this.meta.operations.iterateOverAllOperations((patch) => {
                    operations.push({
                        data: patch.data,
                        oid: patch.oid,
                        timestamp: patch.timestamp,
                    });
                    affectedDocs.add(getOidRoot(patch.oid));
                }, {
                    mode: 'readwrite',
                });
            }
            // we only need to send baselines if we've never synced before
            let baselines = [];
            if (!provideChangesSince) {
                baselines = await this.meta.baselines.getAllSince('');
            }
            return {
                type: 'sync',
                schemaVersion: this.meta.schema.currentVersion,
                timestamp: this.meta.now,
                replicaId: localReplicaInfo.id,
                resyncAll: !localReplicaInfo.lastSyncedLogicalTime,
                operations,
                baselines,
                since: provideChangesSince,
            };
        };
        this.createPresenceUpdate = async (presence) => {
            const localReplicaInfo = await this.meta.localReplica.get();
            return {
                type: 'presence-update',
                presence,
                replicaId: localReplicaInfo.id,
            };
        };
        this.createHeartbeat = async () => {
            const localReplicaInfo = await this.meta.localReplica.get();
            return {
                type: 'heartbeat',
                timestamp: this.meta.now,
                replicaId: localReplicaInfo.id,
            };
        };
        this.createAck = async (nonce) => {
            const localReplicaInfo = await this.meta.localReplica.get();
            return {
                type: 'ack',
                timestamp: this.meta.now,
                replicaId: localReplicaInfo.id,
                nonce,
            };
        };
    }
}
//# sourceMappingURL=MessageCreator.js.map